import React, { useState } from "react";
import { ChevronDown } from "lucide-react"; 

const CustomDropdown = ({ options, value, onChange, placeholder }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  const truncateText = (text) => {
    if (text.length > 12) {
      return `${text.slice(0, 12)}...`;
    }
    return text;
  };

  return (
    <div className="relative w-full">
      <button
        className="w-full p-2 border rounded flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="truncate" title={value || placeholder}>
          {truncateText(value || placeholder)}
        </span>
        <ChevronDown className={`ml-2 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} />
      </button>
      {isOpen && (
        <ul
          className="absolute z-10 bg-white border rounded mt-2 w-full shadow-lg max-h-48 overflow-y-auto"
          style={{ maxHeight: '12rem' }} 
        >
          
          {placeholder && (
            <li
              className={`p-2 hover:bg-gray-200 cursor-pointer ${!value ? 'font-bold' : ''}`}
              onClick={() => handleSelect('')}
            >
              {placeholder}
            </li>
          )}

          {options.map((option, index) => (
            <li
              key={index}
              className={`p-2 hover:bg-gray-200 cursor-pointer ${value === option ? 'font-bold' : ''}`}
              onClick={() => handleSelect(option)}
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomDropdown;
